import { Instance } from 'mobx-state-tree';
import { VisitIdsDtoModelBase } from './VisitIdsDtoModel.base';

/* The TypeScript type of an instance of VisitIdsDtoModel */
export interface VisitIdsDtoModelType extends Instance<typeof VisitIdsDtoModel.Type> {}

/* A graphql query fragment builders for VisitIdsDtoModel */
export { selectFromVisitIdsDto, visitIdsDtoModelPrimitives, VisitIdsDtoModelSelector } from './VisitIdsDtoModel.base';

/**
 * VisitIdsDtoModel
 */
export const VisitIdsDtoModel = VisitIdsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
